import React, { useEffect, useRef, useState } from "react";
import Select from "../../../../components/Select";
import TimePicker from "../../../../components/DatePicker/TimePicker";
import { forEach } from "lodash-es";
import { isEmpty } from "lodash";
import { DAY_OF_WEEKS } from "../../../../constants/DAY";
import { translation } from "../../../../utils/translator";
import { DAY_TYPES } from "../../../../constants/WORK";

const ScheduleItem = ({
  day,
  dayType,
  onTypeChange,
  workStart,
  workEnd,
  restTimes,
  height,
  onWorkTimeChange,
  onRestTimeChange,
  handleAddRestTime,
  handleRemoveRestTime,
  mode
}) => {
  return (
    <div className="day-group">
      <p className="day-name">
        {translation(DAY_OF_WEEKS, day, "fullName", "label")}
      </p>
      <Select
        name="dayType"
        className="day-type-select"
        value={dayType}
        list={DAY_TYPES}
        onChange={(e) => onTypeChange(e, day)}
        disabled={mode === 'view'}
      />
      {dayType === "workday" ? (
        <div className="workday-container">
          <div className="workday-wrap">
            <p className="workday-label">근무시간</p>
            <div className="time-picker-wrap">
              <TimePicker
                isRange
                defaultValue={{ from: workStart, to: workEnd }}
                defaultPickerHour={{ from: 9, to: 18 }}
                onChange={(time) => {
                  onWorkTimeChange(time, day);
                }}
                disabled={mode === 'view'}
              />
            </div>
          </div>
          <div className="workday-wrap rest">
            <p className="workday-label">휴게시간</p>
            {!isEmpty(restTimes) &&
              restTimes.map((rest, idx) => (
                <div className="time-picker-wrap rest" key={idx}>
                  <TimePicker
                    isRange
                    defaultValue={{ from: rest.restStart, to: rest.restEnd }}
                    defaultPickerHour={{ from: 12, to: 13 }}
                    onChange={(time) => {
                      onRestTimeChange(time, day, idx);
                    }}
                    disabled={mode === 'view'}
                  />
                  {idx !== 0 && mode !== 'view' &&(
                    <div className="rest-btn-wrap">
                      <button
                        className="rest-btn remove"
                        onClick={() => handleRemoveRestTime(day, idx)}
                      >
                        삭제
                      </button>
                    </div>
                  )}
                </div>
              ))}
            {mode !== 'view' &&(
            <div className="rest-btn-wrap">
              <button
                className="rest-btn add"
                onClick={() => handleAddRestTime(day)}
              >
                추가
              </button>
            </div>
            )}
          </div>
        </div>
      ) : (
        <div className="rest-time-container"style={{ height }} />
      )}
    </div>
  );
};

const WeeklyWorkSchedule = ({ dayList, setDayList, mode }) => {
  const [height, setHeight] = useState(0);
  const workScheduleRef = useRef();

  useEffect(() => {
    if (workScheduleRef && workScheduleRef.current) {
      setHeight(workScheduleRef.current.offsetHeight - 94);
    }
  }, [workScheduleRef]);

  const handleOnChange = (e, dayName) => {
    const { name, value } = e.target;
    setDayList((oldVal) =>
      [...oldVal].map((obj) => {
        if (obj.day === dayName) {
          return {
            ...obj,
            [name]: value,
          };
        } else return obj;
      })
    );
  };

  const handleOnChangeWorkTime = (t, dayName) => {
    const { from, to } = t;
    setDayList((oldVal) =>
      [...oldVal].map((obj) => {
        if (obj.day === dayName) {
          return {
            ...obj,
            ...from ? { workStart: from } : {},
            ...to ? { workEnd: to } : {},
          };
        } else return obj;
      })
    );
  };

  const handleOnChangeRestTime = (t, dayName, idx) => {
    const { from, to } = t;
    setDayList((oldVal) =>
      [...oldVal].map((obj) => {
        if (obj.day === dayName) {
          forEach(obj.restTimes, (rest, index) => {
            if (index === idx) {
              if (from) {
                rest.restStart = from;
              }
              if (to) {
                rest.restEnd = to;
              }
            }
          });
          return obj;
        } else return obj;
      })
    );
  };

  const handleAddrestTime = (dayName) => {
    setDayList((oldVal) =>
      [...oldVal].map((obj) => {
        if (obj.day === dayName) {
          return {
            ...obj,
            restTimes: [
              ...obj.restTimes,
              { restStart: "12:00:00", restEnd: "13:00:00" },
            ],
          };
        } else return obj;
      })
    );
  };

  const handleRemoveRestTime = (dayName, idx) => {
    setDayList((oldVal) =>
      [...oldVal].map((obj) => {
        if (obj.day === dayName) {
          forEach(obj.restTimes, (rest, index) => {
            if (index === idx) {
              obj.restTimes.splice(index, 1);
            }
          });
          return obj;
        } else return obj;
      })
    );
  };

  return (
    <div className="create-work-schedule" ref={workScheduleRef}>
      {!isEmpty(dayList) &&
        dayList.map((day, index) => (
          <ScheduleItem
            {...day}
            key={index}
            onTypeChange={handleOnChange}
            onWorkTimeChange={handleOnChangeWorkTime}
            onRestTimeChange={handleOnChangeRestTime}
            handleAddRestTime={handleAddrestTime}
            handleRemoveRestTime={handleRemoveRestTime}
            height={height}
            mode={mode}
          />
        ))}
    </div>
  );
};

export default WeeklyWorkSchedule;
